import React from "react";
import { Link } from "react-router-dom";
import "./CompanyProfile.css";

/* Small label/value row for At a Glance (now placed inside grid cells) */
const GlanceItem = ({ label, children }) => (
  <div className="glance-item">
    <div className="glance-label">{label}</div>
    <div className="glance-value">{children ?? <em>—</em>}</div>
  </div>
);

const CompanyProfile = () => {
  return (
    <div className="row clearfix">
      <div className="col-sm-2"></div>
      <div className="col-sm-9" style={{ padding: 0 }}>
        <div className="container-fluid">
          {/* Header */}
          <div className="block-header">
            <div className="row clearfix">
              <div className="col-md-6 col-sm-12">
                <h2>Company Info</h2>
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">Company Info</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>

          {/* Subtle note */}
          <div className="row clearfix">
            <div className="col-xl-12">
              <div className="small text-muted mb-3">
                Need emails, phone or address? See{" "}
                <Link to="/contact" className="text-primary font-weight-600">Contact Us</Link>.
              </div>
            </div>
          </div>

                    {/* At a Glance */}
          <div className="row clearfix">
            <div className="col-xl-12">
              <div className="card glance-card">
                <div className="header">
                  <h2>At a Glance</h2>
                </div>

                <div className="body">
                  <div className="glance-grid">
                    {/* LEFT COLUMN */}
                    <div className="gl-col">
                      <div className="gl-row">
                        <span className="gl-label">Company Name</span>
                        <span className="gl-value">iOdin (by Aeger Group AS)</span>
                      </div>

                      <div className="gl-row">
                        <span className="gl-label">Business Type</span>
                        <span className="gl-value">
                          Cybersecurity / Threat Consultancy &amp; ASOC etc.
                        </span>
                      </div>

                      <div className="gl-row">
                        <span className="gl-label">Founded</span>
                        <span className="gl-value">—</span>
                      </div>

                      <div className="gl-row">
                        <span className="gl-label">Headquarters</span>
                        <span className="gl-value">Oslo, Norway</span>
                      </div>
                    </div>

                    {/* RIGHT COLUMN */}
                    <div className="gl-col">
                      <div className="gl-row">
                        <span className="gl-label">Organization No. (Org.nr)</span>
                        <span className="gl-value">899 185 412</span>
                      </div>

                      <div className="gl-row">
                        <span className="gl-label">VAT ID</span>
                        <span className="gl-value">NO 899 185</span>
                      </div>

                      <div className="gl-row">
                        <span className="gl-label">Primary Domains</span>
                        <span className="gl-value">
                          <a
                            href="https://iodin.io"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="gl-chip"
                          >
                            iodin.io
                          </a>
                        </span>
                      </div>

                      <div className="gl-row">
                        <span className="gl-label">Legal Entity</span>
                        <span className="gl-value">Aeger Group AS</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


          {/* Meet the team (CSS Grid) */}
          <div className="row clearfix">
            <div className="col-xl-12">
              <div className="card">
                <div className="header text-center">
                  <h6 className="text-primary">Meet the team</h6>
                  <h2>Our Experts</h2>
                  <p className="text-muted">
                    Our team of experts brings deep industry knowledge and hands-on experience,
                    delivering cutting-edge solutions that drive success and innovation across multiple sectors.
                  </p>
                </div>

                <div className="body">
                  <div className="team-grid">
                    {/* Card 1 */}
                    <div className="team-card">
                      <img
                        src="https://randomuser.me/api/portraits/men/32.jpg"
                        alt="Christian Warhuus"
                        className="team-avatar"
                      />
                      <h5 className="team-name">Christian Warhuus</h5>
                      <p className="team-text">
                        Industry leader with over two decades of global experience in implementing,
                        building, and leading solutions that span GRC, application, cloud, and network security.
                      </p>
                    </div>

                    {/* Card 2 */}
                    <div className="team-card">
                      <img
                        src="https://randomuser.me/api/portraits/men/33.jpg"
                        alt="Thomas Warhuus"
                        className="team-avatar"
                      />
                      <h5 className="team-name">Thomas Warhuus</h5>
                      <p className="team-text">
                        HR Leader with expertise in managing Indian operations, dedicated to optimizing remote work
                        processes and enhancing employee engagement to drive organizational growth.
                      </p>
                    </div>

                    {/* Card 3 */}
                    <div className="team-card">
                      <img
                        src="https://randomuser.me/api/portraits/men/85.jpg"
                        alt="Samarbir Singh"
                        className="team-avatar"
                      />
                      <h5 className="team-name">Samarbir Singh</h5>
                      <p className="team-text">
                        Cybersecurity leader with over two decades of experience in the cyber security
                        and information security domains.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Services & Compliance (CSS Grid wrapper) */}
          <div className="row clearfix">
            <div className="col-xl-12">
              <div className="two-col-grid">
                {/* Services */}
                <div className="card">
                  <div className="header">
                    <h2>Services Snapshot</h2>
                  </div>
                  <div className="body">
                    <ul className="list-unstyled mb-3 bullet-list">
                      <li><span className="legend legend-1" /> External Attack Surface Management</li>
                      <li><span className="legend legend-2" /> Threat Intelligence &amp; Dark Web Monitoring</li>
                      <li><span className="legend legend-3" /> Vulnerability Assessment &amp; Pen Testing (VAPT)</li>
                      <li><span className="legend legend-4" /> Real-time Alerts &amp; Incident Guidance</li>
                      <li><span className="legend legend-5" /> Compliance Reporting &amp; Dashboards</li>
                    </ul>
                    <Link to="/services" className="btn btn-outline-primary btn-sm btn-round">
                      Explore Services
                    </Link>
                  </div>
                </div>

                {/* Compliance */}
                <div className="card">
                  <div className="header">
                    <h2>Compliance Highlights</h2>
                  </div>
                  <div className="body">
                    <ul className="list-unstyled mb-3 bullet-list">
                      <li><span className="legend legend-ok" /> GDPR-aligned processing &amp; DPA on request</li>
                      <li><span className="legend legend-ok" /> Practices aligned to ISO/IEC 27001</li>
                      <li><span className="legend legend-ok" /> Encryption in transit &amp; at rest, RBAC</li>
                      <li><span className="legend legend-ok" /> Security testing &amp; vendor risk reviews</li>
                    </ul>
                    <div className="btn-row">
                      <Link to="/privacy" className="btn btn-outline-primary btn-sm btn-round mr-2">Privacy Info</Link>
                      <Link to="/legal" className="btn btn-outline-primary btn-sm btn-round">Legal Info</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* /Services & Compliance */}
        </div>
      </div>
    </div>
  );
};

export default CompanyProfile;
